import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogProps,
  FormControl,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import React, { ChangeEvent, useCallback, useState } from "react";
import Radio from "@mui/material/Radio";
// import styles from "@/styles/components/filterModal.module.scss";
import assest from "../../json/assest";
import { useAppDispatch } from "../../hooks/useAppDispatch";
// import {
//   setHasNote,
//   setUnreachableSubmitter,
//   setHasMessage,
//   setMonth,
//   setYear,
//   setSubmitPlace,
//   setUserId,
//   setManagerId,
//   setQualityTeamId,
//   setPeopleAppearing,
//   setPersonWhoFilmed,
//   setSubmitOtherWebsite,
//   setAgreementWithAnotherCompany,
// } from "../../redux-toolkit/slices/qc.confirm.approved.approved.slice";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
  sampleMonthsValueArray,
  sampleYearList,
  truncateString,
} from "../../lib/functions/utils.lib";
import modalstyle from "../../styles/components/Superadmin/manager-deniedfilter.module.scss";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      "& .MuiList-root": {
        "& .MuiMenuItem-root": {
          fontWeight: "500",
          fontSize: "11px",
          color: "#525050",
        },
      },
    },
  },
};

const dialogContainer = {
  [`.MuiDialog-container`]: {
    alignItems: "flex-start",

    [`.MuiDialog-paper`]: {
      marginTop: "72px",
      boxShadow: "none",
      borderRadius: "10px !important",
      [`.MuiDialogContent-root`]: {
        padding: "0 11px",
        overflowX: "hidden",
      },
    },
  },
};

import countries from "countries-list";
import RefreshIconBlack from "../../ui/Icons/RefreshIconBlack";
import RefreshIconBlue from "../../ui/Icons/RefreshIconBlue";
import dropdownStyles from "../../lib/functions/dropwdownstyles";

const ManagerDeniedWebsiteApprovedfilterModal = (props) => {
  const countryNames = Object.values(countries.countries).map(
    (country) => country.name
  );
  // console.warn('countryNames', countryNames);
  // const {
  //   has_note,
  //   unreachable_submitter,
  //   hasMessage,
  //   month,
  //   year,
  //   submit_place,
  //   user_id,
  //   manager_id,
  //   quality_team_id,
  //   people_appearing,
  //   person_who_filmed,
  //   submit_other_website,
  //   aggrement_with_another_company,
  // } = useAppSelector((s) => s.dashboardApproveApproveSlice);

  const { acquisitors, managers, qualityTeam } = useAppSelector(
    (s) => s.appStateSlice
  );

  const {
    hideBottom,
    onClose,
    modalFields,
    approvedByColName,
    confirmedByColName,
    ...rest
  } = props;

  // console.warn("first", approvedByColName, confirmedByColName);

  const {
    has_note,
    unreachable_submitter,
    hasMessage,
    month,
    year,
    submit_place,
    user_id,
    // manager_id,
    quality_team_id,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
  } = props.states;
  const {
    setHasNote,
    setUnreachableSubmitter,
    setHasMessage,
    setMonth,
    setYear,
    setSubmitPlace,
    setUserId,
    // setManagerId,
    setQualityTeamId,
    setPeopleAppearing,
    setPersonWhoFilmed,
    setSubmitOtherWebsite,
    setAgreementWithAnotherCompany,
  } = props.setStates;

  const dispatch = useAppDispatch();

  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  // console.warn('qualityTeam', qualityTeam)

  const [mockMonth, setMockMonth] = useState();
  const [mockUser, setMockUser] = useState();
  const [mockQualityTeam, setMockQualityTeam] = useState();

  return (
    <>
      <Dialog
        {...rest}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "787px",
            position: "relative",
          },
        }}
        sx={dialogContainer}
      >
        <DialogContent>
          <Box className={modalstyle.dialog_wrapper}>
            <Box className={modalstyle.dialog_top}>
              <Typography variant="h3" className={modalstyle.heading}>
                Filter
              </Typography>
              <Button
                onClick={() => {
                  props.handleClearFilterModal();
                  handleClose();
                }}
                className={modalstyle.refresh_btn}
              >
                <Typography variant="caption" className={modalstyle.icon}>
                  <RefreshIconBlack />
                </Typography>
                <Typography variant="caption" className={modalstyle.text}>
                  Clear
                </Typography>
              </Button>
            </Box>
            <Box className={modalstyle.dialog_middle}>
              <Box className={modalstyle.form_wrapper}>
                <form>
                  <Box className={modalstyle.form_one}>
                    <Box className={modalstyle.form_row}>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.gridColumn1}`}
                      >
                        <Box className={`${modalstyle.groupAcquisitor}`}>
                          <label className={modalstyle.innerLabel}>
                            <Typography variant="caption">
                              Has Notes?
                            </Typography>
                            <Button
                              type="button"
                              className={modalstyle.refresh_btn}
                              onClick={() => dispatch(setHasNote(null))}
                            >
                              <RefreshIconBlue />
                            </Button>
                          </label>
                          <Box className={modalstyle.radio_group}>
                            <RadioGroup
                              row
                              value={has_note != null ? has_note : null}
                              name="has_note"
                              onChange={(e) =>
                                dispatch(setHasNote(e.target.value))
                              }
                            >
                              <FormControlLabel
                                value="Yes"
                                control={<Radio />}
                                label="Yes"
                              />
                              <FormControlLabel
                                value="No"
                                control={<Radio />}
                                label="No"
                              />
                            </RadioGroup>
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.gridColumn2}`}
                      >
                        <Box className={`${modalstyle.groupFilmedIn}`}>
                          <label className={modalstyle.innerLabel}>
                            <Typography variant="caption">
                              Unreachable Submitter?
                            </Typography>
                            <Button
                              type="button"
                              className={modalstyle.refresh_btn}
                              onClick={() =>
                                dispatch(setUnreachableSubmitter(null))
                              }
                            >
                              <RefreshIconBlue />
                            </Button>
                          </label>
                          <Box className={modalstyle.radio_group}>
                            <RadioGroup
                              row
                              value={unreachable_submitter}
                              name="unreachable_submitter"
                              onChange={(e) =>
                                dispatch(
                                  setUnreachableSubmitter(e.target.value)
                                )
                              }
                            >
                              <FormControlLabel
                                value="Yes"
                                control={<Radio />}
                                label="Yes"
                              />
                              <FormControlLabel
                                value="No"
                                control={<Radio />}
                                label="No"
                              />
                            </RadioGroup>
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.gridColumn3}`}
                      >
                        <Box className={`${modalstyle.groupFilmedLocation}`}>
                          <label className={modalstyle.innerLabel}>
                            <Typography variant="caption">
                              Has Pending Message
                            </Typography>
                            <Button
                              type="button"
                              className={modalstyle.refresh_btn}
                              onClick={() => dispatch(setHasMessage(null))}
                            >
                              <RefreshIconBlue />
                            </Button>
                          </label>
                          <Box className={modalstyle.radio_group}>
                            <RadioGroup
                              row
                              value={hasMessage}
                              name="has_message"
                              onChange={(e) =>
                                dispatch(setHasMessage(e.target.value))
                              }
                            >
                              <FormControlLabel
                                value="Yes"
                                control={<Radio />}
                                label="Yes"
                              />
                              <FormControlLabel
                                value="No"
                                control={<Radio />}
                                label="No"
                              />
                            </RadioGroup>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      className={`${modalstyle.form_row} ${modalstyle.multiSelectRow}`}
                    >
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.gridColumn1}`}
                      >
                        <Box className={`${modalstyle.groupAcquisitor}`}>
                          <label>
                            <Typography variant="caption">Filmed in</Typography>
                            <Button
                              type="button"
                              className={modalstyle.refresh_btn}
                              onClick={() => {
                                dispatch(setYear(null));
                                dispatch(setMonth(null));
                              }}
                            >
                              <RefreshIconBlue />
                            </Button>
                          </label>
                          <Box className={modalstyle.select_wrap}>
                            <Box
                              className={`${modalstyle.input_group} ${modalstyle.input_month}`}
                            >
                              <Select
                                labelId="month-label"
                                id="month-select"
                                displayEmpty
                                value={month}
                                renderValue={() => {
                                  // console.warn('selected', selected)
                                  if (!month) {
                                    return <span>Month</span>;
                                  } else {
                                    return <span>{mockMonth.month}</span>;
                                  }
                                }}
                                MenuProps={MenuProps}
                                inputProps={{
                                  "aria-label": "Without label",
                                }}
                                onChange={(e) => {
                                  dispatch(setMonth(e.target.value.value));
                                  setMockMonth(e.target.value);
                                  // console.warn("e.target.value", e.target.value);
                                }}
                              >
                                {sampleMonthsValueArray.map((m, i) => (
                                  <MenuItem key={i} value={m}>
                                    {m.month}
                                  </MenuItem>
                                ))}
                              </Select>
                            </Box>
                            <Box
                              className={`${modalstyle.input_group} ${modalstyle.input_year}`}
                            >
                              <Select
                                labelId="year-label"
                                id="year-select"
                                displayEmpty
                                value={year}
                                renderValue={(selected) => {
                                  if (!selected) {
                                    return <span>Year</span>;
                                  } else {
                                    return <span>{selected}</span>;
                                  }
                                }}
                                MenuProps={MenuProps}
                                inputProps={{
                                  "aria-label": "Without label",
                                }}
                                onChange={(e) => {
                                  dispatch(setYear(e.target.value));
                                }}
                              >
                                {sampleYearList.map((y, i) => (
                                  <MenuItem key={i} value={y}>
                                    {y}
                                  </MenuItem>
                                ))}
                              </Select>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.gridColumn2}`}
                      >
                        <Box className={`${modalstyle.groupFilmedIn}`}>
                          <label>
                            <Typography variant="caption">
                              Filming Location
                            </Typography>
                            <Button
                              type="button"
                              className={modalstyle.refresh_btn}
                              onClick={() => dispatch(setSubmitPlace(null))}
                            >
                              <RefreshIconBlue />
                            </Button>
                          </label>
                          <Box className={modalstyle.input_group}>
                            <Select
                              labelId="location-label"
                              id="location-select"
                              displayEmpty
                              value={submit_place}
                              renderValue={(selected) => {
                                if (!selected) {
                                  return <span>Location</span>;
                                } else {
                                  return <span>{selected}</span>;
                                }
                              }}
                              MenuProps={{
                                PaperProps: {
                                  sx: dropdownStyles(),
                                },
                              }}
                              inputProps={{
                                "aria-label": "Without label",
                              }}
                              onChange={(e) => {
                                dispatch(setSubmitPlace(e.target.value));
                              }}
                              sx={{ width: "160px !important" }}
                            >
                              {countryNames.map((p, i) => (
                                <MenuItem key={i} value={p}>
                                  {truncateString(p, 20)}
                                </MenuItem>
                              ))}
                            </Select>
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.gridColumn3}`}
                      >
                        <Box className={`${modalstyle.groupFilmedLocation}`}>
                          <label>
                            <Typography variant="caption">
                              Acquisitor
                            </Typography>
                            <Button
                              type="button"
                              className={modalstyle.refresh_btn}
                              onClick={() => dispatch(setUserId(null))}
                            >
                              <RefreshIconBlue />
                            </Button>
                          </label>
                          <Box className={modalstyle.input_group}>
                            <Select
                              labelId="user-label"
                              id="user-select"
                              displayEmpty
                              value={user_id}
                              renderValue={() => {
                                if (!user_id) {
                                  return <span>Acquisitor</span>;
                                } else {
                                  return <span>{mockUser?.name}</span>;
                                }
                              }}
                              MenuProps={{
                                PaperProps: {
                                  sx: dropdownStyles(),
                                },
                              }}
                              inputProps={{
                                "aria-label": "Without label",
                              }}
                              onChange={(e) => {
                                dispatch(setUserId(e.target.value.id));
                                setMockUser(e.target.value);
                              }}
                              sx={{ width: "183px !important" }}
                            >
                              {acquisitors?.map((a, i) => (
                                <MenuItem key={i} value={a}>
                                  {a.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.gridColumn1}`}
                      >
                        <Box className={`${modalstyle.groupAcquisitor}`}>
                          <label>
                            <Typography variant="caption">
                              Approved by
                            </Typography>
                            <Button
                              type="button"
                              className={modalstyle.refresh_btn}
                              onClick={() => dispatch(setManagerId(null))}
                            >
                              <RefreshIconBlue />
                            </Button>
                          </label>
                          <Box className={modalstyle.input_group}>
                            <Select
                              labelId="user-label"
                              id="user-select"
                              displayEmpty
                              value={quality_team_id}
                              renderValue={() => {
                                if (!quality_team_id) {
                                  return <span>{approvedByColName}</span>;
                                } else {
                                  return <span>{mockQualityTeam?.name}</span>;
                                }
                              }}
                              MenuProps={{
                                PaperProps: {
                                  sx: dropdownStyles(),
                                },
                              }}
                              inputProps={{
                                "aria-label": "Without label",
                              }}
                              onChange={(e) => {
                                dispatch(setQualityTeamId(e.target.value.id));
                                setMockQualityTeam(e.target.value);
                              }}
                            >
                              {qualityTeam?.map((a, i) => (
                                <MenuItem key={i} value={a}>
                                  {a.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className={modalstyle.form_two}>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Are There People Appearing In The Video?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => dispatch(setPeopleAppearing(null))}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            value={people_appearing}
                            name="people_appearing"
                            onChange={(e) =>
                              dispatch(setPeopleAppearing(e.target.value))
                            }
                          >
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            The Person Who Filmed This Video Is:
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => dispatch(setPersonWhoFilmed(null))}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            value={
                              person_who_filmed != null
                                ? person_who_filmed
                                : null
                            }
                            name="person_who_filmed"
                            onChange={(e) =>
                              dispatch(setPersonWhoFilmed(e.target.value))
                            }
                          >
                            <FormControlLabel
                              value="Me"
                              control={<Radio />}
                              label="Me"
                            />
                            <FormControlLabel
                              value="A Family Member"
                              control={<Radio />}
                              label="A Family Member"
                            />
                            <FormControlLabel
                              value="A Friend"
                              control={<Radio />}
                              label="A Friend"
                            />
                            <FormControlLabel
                              value="Someone I Know"
                              control={<Radio />}
                              label="Someone I Know"
                            />
                            <FormControlLabel
                              value="A Dashcam"
                              control={<Radio />}
                              label="A Dashcam"
                            />
                            <FormControlLabel
                              value="A Security Camera"
                              control={<Radio />}
                              label="A Security Camera"
                            />
                            <FormControlLabel
                              value="Other: the kid of my friend"
                              control={<Radio />}
                              label={
                                <>
                                  Other: <span>the kind of my friend</span>
                                </>
                              }
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Did You Send/Submit/Upload This Video To A Website
                            And/Or Social Media Account?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              dispatch(setSubmitOtherWebsite(null))
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            value={
                              submit_other_website != null
                                ? submit_other_website
                                : null
                            }
                            name="submit_other_website"
                            onChange={(e) =>
                              dispatch(setSubmitOtherWebsite(e.target.value))
                            }
                          >
                            <FormControlLabel
                              value="No, I Did Not"
                              control={<Radio />}
                              label="No, I Did Not"
                            />
                            <FormControlLabel
                              value="Yes, Another Company's Website"
                              control={<Radio />}
                              label="Yes, Another Company's Website"
                            />
                            <FormControlLabel
                              value="Yes, A Facebook Page"
                              control={<Radio />}
                              label="Yes, A Facebook Page"
                            />
                            <FormControlLabel
                              value="Yes, A Twitter Account"
                              control={<Radio />}
                              label="Yes, A Twitter Account"
                            />
                            <FormControlLabel
                              value="Yes, An Instagram Account"
                              control={<Radio />}
                              label="Yes, An Instagram Account"
                            />
                            <FormControlLabel
                              value="Yes, A YouTube Channel"
                              control={<Radio />}
                              label="Yes, A YouTube Channel"
                            />
                            <FormControlLabel
                              value="Yes, A Snaphat Account"
                              control={<Radio />}
                              label="Yes, A Snaphat Account"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Did You Sign A Licensing Agreement For This Video
                            With Another Company/Page?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              dispatch(setAgreementWithAnotherCompany(null))
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            value={
                              aggrement_with_another_company != null
                                ? aggrement_with_another_company
                                : null
                            }
                            name="aggrement_with_another_company"
                            onChange={(e) =>
                              dispatch(
                                setAgreementWithAnotherCompany(e.target.value)
                              )
                            }
                          >
                            <FormControlLabel
                              value="No, I Did Not"
                              control={<Radio />}
                              label="No, I Did Not"
                            />
                            <FormControlLabel
                              value="Yes, I Have Filled An Online Form"
                              control={<Radio />}
                              label="Yes, I Have Filled An Online Form"
                            />
                            <FormControlLabel
                              value="Yes, I Have Signed An Exclusive Agreement"
                              control={<Radio />}
                              label="Yes, I Have Signed An Exclusive Agreement"
                            />
                            <FormControlLabel
                              value="Yes, I Have Signed A Non-Exclusive Agreement"
                              control={<Radio />}
                              label="Yes, I Have Signed A Non-Exclusive Agreement"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </form>
              </Box>
            </Box>
            <Box className={modalstyle.dialog_bottom}>
              <Box className={modalstyle.btn_holder}>
                <Button
                  type="button"
                  className={modalstyle.cancel_btn}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  className={modalstyle.submit_btn}
                  onClick={() => {
                    handleClose();
                    props.filterRefetch();
                  }}
                >
                  Filter <strong>now</strong>
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ManagerDeniedWebsiteApprovedfilterModal;
